const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const getDateStringFromTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

const getDateStringWithoutYearFromTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
}

const getDateStringPlusOneMonthWithoutYearFromTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);
  date.setMonth(date.getMonth() + 1)

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
}

const submitToKlaviyo = async ({ first_name, email, zip_code, phone, plan_selected }) => {
  const response = await fetch(
    "https://a.klaviyo.com/client/subscriptions/?company_id=Sua8Hm",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "revision": "2023-12-15",
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "funnel",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  first_name,
                  email,
                  location: { zip: zip_code },
                  ...(phone ? { phone_number: phone } : {}),
                  properties: {
                    source: "funnel",
                    plan_selected,
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "SrEykK", // ← from Klaviyo > Lists & Segments
              },
            },
          },
        },
      }),
    }
  );

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.errors?.[0]?.detail || "Klaviyo submission failed");
  }
}
